import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { reducers, metaReducers } from './';
import { environment } from '../../environments/environment';

import { AuthEffects } from '../auth/store/auth.effects';
import { SessionEffects } from './session.effects';
import { ClientsEffects } from '../clients/client-list/store/clients.effects';
import { ClientEffects } from '../clients/client-details/store/client.effects';
import { NewClientEffects } from '../clients/new-client/store/new-client.effects';
import { NotificationsEffects } from '../notifications/store/notifications.effects';
import { ClientOptionsEffects } from '../clients/client-details/store/client-options.effects';
import { ChecklistsEffects } from 'app/checklists/store/checklists.effects';
import { TimetrackEffects } from 'app/timetrack/store/timetrack.effects';
import { TasksEffects } from 'app/tasks/store/tasks.effects';
import { CasesEffects } from 'app/clients/client-details/cases/store/cases.effects';
import { SettingsEffects } from 'app/settings/store/settings.effects';
import { StandardteksterEffects } from './standardtekster.effects';
import { V2StandardteksterEffects } from './v2-standardtekster.effects';

@NgModule({ exports: [
        StoreModule,
        EffectsModule
    ], imports: [CommonModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false
            }
        }),
        EffectsModule.forRoot([
            AuthEffects,
            SessionEffects,
            ClientsEffects,
            ClientEffects,
            NewClientEffects,
            NotificationsEffects,
            ClientOptionsEffects,
            ChecklistsEffects,
            TimetrackEffects,
            TasksEffects,
            CasesEffects,
            SettingsEffects,
            StandardteksterEffects,
            V2StandardteksterEffects
        ]),
        StoreDevtoolsModule.instrument({
            name: 'NgRx QWM DevTools',
            logOnly: environment.production
        })], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppStoreModule {}
